import React from "react";
import { connect } from "react-redux";
import { Button } from "@vds/buttons";
import { TileContainer } from "@vds/tiles";
import { Title } from "@vds/typography";

function EmberWiFiExtender(props) {
  const {
    dispatch,
    product,
    clickFn,
    buildProduct,
    isChecked,
    ecProfileCart,
    isBlocked,
    cart
  } = props;
  const isClassicFlow = !buildProduct?.mnFromApi;

  const WIFIExtender = product => {
    let showPrice = null
    if (buildProduct?.fne?.selectedProduct?.id === product?.id) {
      showPrice = parseFloat(buildProduct?.fne?.selectedProduct?.originalPrice) * parseFloat(buildProduct?.fne?.unitCount)
    }
    return (
      <>
        {product?.unitCount !== "6" && (
          <TileContainer
            padding='12px'
            aspectRatio='3:4'
            width='174px'
            height='228px'
            onClick={(e) => {
              e.stopPropagation();
            }}
            backgroundColor="white"
            showBorder={true}
          >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <TileContainer aspectRatio='3:4' width='142px' height='96px' backgroundColor={""} padding='20px 25px'>
                <Title color='black' size="3XSmall"><b> {product?.name} </b></Title>
              </TileContainer>
              <Title color='black' size='small'  >
                <p style={{ 'text-align': 'center', 'font-size': '1.25rem', 'margin-bottom': '1rem' }}>
                  {showPrice
                    ? '$' + showPrice + (!product?.name?.toLowerCase()?.includes('buy') ? '/mo' : '')
                    : isClassicFlow
                      ? (`${product?.displayPrice?.indexOf(".00") > -1 ? product?.displayPrice?.split(".")?.[0] : product?.displayPrice}/mo`)
                      : (product?.unitCount == "1"
                        ? product?.displayPrice + (!product?.name?.toLowerCase()?.includes('buy') ? '/mo' : '/mo')
                        : `${product?.displayPrice?.indexOf(".00")!== -1 ?
                           product?.displayPrice?.split(".")?.[0]+"/mo" : showPrice !== null ? '$' + showPrice : product?.displayPrice+"/mo"}`
                      )
                  }
                </p>
              </Title>
              {(ecProfileCart?.ProfileFneProduct?.prodId == product?.id && buildProduct?.fne?.selectedProduct == null)
                ? <p className='fne-selected-btn'>Selected</p>
                : isChecked
                  ? (<p className='fne-selected-btn'>Selected</p>)
                  : (
                    <Button
                      id="select-btn-extender"
                      size="large"
                      surface="light"
                      disabled={isBlocked ? true : false}
                      use="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        clickFn();
                      }}
                    >
                      Select
                    </Button>
                  )
              }
            </div>
          </TileContainer>
        )}
      </>
    );
  }

  return (
    <WIFIExtender {...product} />
  );
}

const mapStateToProps = state => {
  return {
    buildProduct: state.buildProduct,
    ecProfileCart: state.ecProfileCart,
  }
}

export default connect(mapStateToProps)(EmberWiFiExtender);
